module.exports = __webpack_public_path__ + "static/media/as.ea0a310c.svg";